import { type } from 'os';
import styled, { keyframes } from 'styled-components';
import { theme } from '../styles/theme';

// 도트 애니메이션을 위한 keyframes 정의
const bounce = keyframes`
  0%, 100% {
    transform: translateY(5px);
  }
  50% {
    transform: translateY(-5px);
  }
`;
type LoadingDotsParams = {
  $color?: string
}
// 로딩 UI 컴포넌트
const LoadingDots = ({$color}:LoadingDotsParams) => {
  return (
    <DotsContainer>
      <Dot $delay="0s"  $color={$color} />
      <Dot $delay="0.1s"  $color={$color} />
      <Dot $delay="0.2s"  $color={$color} />
    </DotsContainer>
  );
};

// 스타일 정의
const DotsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Dot = styled.div<{ $delay: string, $color?: string }>`
  width: 10px;
  height: 10px;
  margin: 0 5px;
  background-color: ${({$color}) => $color ? $color : theme.colors.white}; ; /* 도트 색상 */
  border-radius: 50%;
  animation: ${bounce} 1s infinite ease-in-out;
  animation-delay: ${({ $delay }) => $delay};
`;

export default LoadingDots;
